//@ts-check
(function () {
  var sectionHeader = document.getElementById('section-header');
  var aboveMobile = window.matchMedia('(min-width: 768px)');
  window.addEventListener('scroll', function (ev) {
    var headerBanners = document.getElementById('header-banners');
    var headerBannersHeight = headerBanners.offsetHeight;
    var topHeight = 0;
    var replaceHeight = 0;

    if (aboveMobile.matches) {
      var headerMainNav = document.querySelector('.MainNav__bottomMenu');
      var headerHeight = sectionHeader.offsetHeight - headerMainNav.offsetHeight;
      replaceHeight = headerMainNav.offsetHeight;
      topHeight = headerBannersHeight + headerHeight;
    } else {
      topHeight = headerBannersHeight;
      replaceHeight = document.querySelector('.Header__top-row').offsetHeight;
    }

    if (window.scrollY >= topHeight) {
      sectionHeader.classList.add('Header--scrolling');
      sectionHeader.style.paddingTop = replaceHeight + 'px';
      document.documentElement.style.setProperty('--header-height', replaceHeight + 'px');
    } else {
      sectionHeader.classList.remove('Header--scrolling');
      sectionHeader.style.paddingTop = '0px';
      document.documentElement.style.setProperty('--header-height', sectionHeader.offsetHeight + 'px');
    }
  });
})();

document.addEventListener('theme:loading:end', (event) => {
  const sortByPopover = document.querySelector('#collection-sort-popover');
  if (sortByPopover) {
    const selectedSortBy = sortByPopover.querySelector('.is-selected');

    if (selectedSortBy) {
      document.querySelector('.CollectionToolbar__Item--sort span').textContent = selectedSortBy.textContent.trim();
      // reset variables from main-collection-template
      if(event.detail != null){
        if(event.detail.loadedProducts && typeof hwCollectionFetchPause != 'undefined'){
          hwCollectionFetchPause = false;
          hwCollectionPagesFetched = [];
          hwCollectionLast = 0;
          hwCollectionPageNext = 2;
          hwCollectionFetchURL = window.location.href + (window.location.href.includes('?sort_by=') ? '&' : '?') + 'page=';
        }
      }
    }
  }

  const productListWrapper = document.querySelector('.ProductListWrapper');

  if (productListWrapper && productListWrapper.dataset.productCount) {
    const productCount = productListWrapper.dataset.productCount;
    const productCountElement = document.querySelector('.CollectionToolbar__ProductCount');
    const splitText = productCountElement.textContent.split(" ");
    splitText[0] = productCount;
    productCountElement.textContent = splitText.join(" ");
  }
});

function rerenderCartDrawer() {
  return fetch(window.routes.cartUrl + '?view=drawer' + '&timestamp=' + Date.now(), {
    credentials: 'same-origin',
    method: 'GET'
  }).then(function (content) {
    content.text().then(function (html) {
      var tempElement = document.createElement('div');
      tempElement.innerHTML = html;

      var cartNodeParent = document.querySelector('.Drawer--cart');
      var cartNodeItemParent = document.querySelector('.Drawer__Items').parentNode;
      var cartNodeFooterParent = document.querySelector('.Drawer__Footer').parentNode;

      cartNodeItemParent.replaceChild(tempElement.querySelector('.Drawer__Items'), document.querySelector('.Drawer__Items'));
      cartNodeParent.replaceChild(tempElement.querySelector('.Drawer__Header--cart'), cartNodeParent.querySelector('.Drawer__Header--cart'));
      cartNodeFooterParent.replaceChild(tempElement.querySelector('.Drawer__Footer'), cartNodeParent.querySelector('.Drawer__Footer'));

      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  })
}

document.addEventListener('theme:loading:end', function (event) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      var cartCount = document.querySelectorAll('.Header__CartDot');
      for (var i in cartCount) {
        cartCount[i].innerHTML = data.item_count;
      }
    });
});


/**
 * Gets a cloudflare url for the specified width
 *
 * @param {string} url
 * @param {string | number} width
 * @returns
 */
function getCloudflareImageUrl(url, width) {
  if (url == '' || url == null || width == undefined) {
    return url;
  }
  var urlParsed = new URL(url);
  urlParsed.pathname = `cdn-cgi/image/width=${width}` + urlParsed.pathname;
  return urlParsed.toString().replace('%7Bwidth%7D', '{width}');
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

//focuses first name on contact form when send a message is clicked
function focusFirstName() {
  var firstNameForm = document.getElementsByName('contact[first_name]');
  firstNameForm[0].focus();
}

var lastClicked = null;
function getID(clicked_id) {
  lastClicked = clicked_id;
}

var hwPageOverlay = document.querySelector('.PageOverlay');
var hwSearchResults = document.getElementById('search_results');
var hwMenuClose = document.querySelector('.closeMobileMenu');
var hwMenuOpen = document.querySelector('.mobileMenu');

document.addEventListener('theme:loading:end', function () {
  if (lastClicked != null) {
    var increases = document.querySelectorAll('#' + lastClicked);
    for (var i = 0; i < increases.length; i++) {
      increases[i].focus();
    }
  }

  var cartButtonMobile = document.querySelector('.cartButtonMobile');
  var cartDrawerClose = document.querySelector('.closeCart');

  hwMenuOpen.addEventListener("click", () => {
    hwMenuOpen.style.display = "none";
    hwMenuClose.style.display = "flex";
    setTimeout(function () {
      hwMenuClose.focus(); //focuses close when when menu open
    }, 300)
  })

  //focuses menu button on mobile close
  hwMenuClose.addEventListener("click", () => {
    hwMenuClose.style.display = "none";
    hwMenuOpen.style.display = "flex";
    setTimeout(function () {
      hwMenuOpen.focus();
    }, 300)
  });

  if(cartButtonMobile && cartDrawerClose){
    //focuses close when when cart open
    cartButtonMobile.addEventListener("click", () => {
      setTimeout(function () {
        cartDrawerClose.focus();
      }, 300)
    });
    //focuses cart icon on cart close.
    cartDrawerClose.addEventListener("click", () => {
      setTimeout(function () {
        cartButtonMobile.focus();
      }, 300)
    });
  }

  if (hwPageOverlay) {
    hwPageOverlay.addEventListener('click', () => {
      if (hwSearchResults) {
        hwSearchResults.setAttribute('aria-hidden', 'true');
      }
      if(hwMenuClose.style.display != 'none') {
        hwMenuClose.click();
      }
    });
  }
});

const hwSearchEl = document.getElementById('Search');

document.addEventListener('theme:search:end', () => {
  hwSearchEl.setAttribute('aria-hidden','false');
  hwPageOverlay.classList.add('is-visible')
});

document.addEventListener('theme:loading:end', function () {
  setTimeout(function () {
    var closedSearch = document.getElementById('searchClose');
    var closedSearchMobile = document.getElementById('searchCloseMobileMenu');
    if (closedSearch) {
      closedSearch.addEventListener('keypress', function (event) {
        if (event.keyCode === 13) {
          this.closest('#search_results').setAttribute('aria-hidden', 'true');
          hwSearchEl.setAttribute('aria-hidden','true');
          document.querySelector('.Search__Input').focus();
          setTimeout(function () {
            document.querySelector('.mobileSearch').focus();
          }, 300)
        }
      })
    }
    if (closedSearchMobile) {
      closedSearchMobile.addEventListener('keypress', function (event) {
        if (event.keyCode === 13) {
          hwSearchEl.setAttribute('aria-hidden','true');
          setTimeout(function () {
            document.querySelector('.mobileSearch').focus();
          }, 300)
        }
      })
    }
  }, 300)
});

//functionality for nav arrows
var mainNavArrows = document.querySelectorAll('.mainNavLinkItem__ArrowContainer');
var arrowsArray = Array.from(mainNavArrows);

function openDropdown(menu, dropdown, item) {
  menu.classList.add('is-expanded');
  var a = menu.querySelector('a[aria-expanded="false"]');
  if(a){
    a.setAttribute('aria-expanded','true');
  }
  item.setAttribute('aria-label', `Close sub-menu ${item.getAttribute('data-tab')}`);
  item.setAttribute('aria-expanded','true');
}

function closeDropdown(menu, dropdown, item) {
  menu.classList.remove('is-expanded');
  var a = menu.querySelector('a[aria-expanded="true"]');
  if(a){
    a.setAttribute('aria-expanded','false');
  }
  item.setAttribute('aria-label', `Open sub-menu ${item.getAttribute('data-tab')}`);
  item.setAttribute('aria-expanded', 'false');
}

arrowsArray.forEach(function (item) {
  var menu = item.closest('.HorizontalList__Item');
  var dropDown = menu.lastElementChild;
  item.addEventListener("keypress", function (e) {
    if (e.key == "Enter") {
      //remove all expanded and up arrows when opening another menu
      arrowsArray.forEach(function (item1) {
        if (item != item1) {
          closeDropdown(item1.closest('.HorizontalList__Item'), item1.closest('.HorizontalList__Item').lastElementChild, item);
        }
      });

      //if expanded remove if not add
      if (menu.classList.contains('is-expanded')) {
        closeDropdown(menu, dropDown, item);
      } else {
        openDropdown(menu, dropDown, item);
      }
    }
  })
  // check for mouse over for hover functionality
  item.closest('.HorizontalList__Item').addEventListener("mouseover", function (e) {
    openDropdown(menu, dropDown, item);
  });

  item.closest('.HorizontalList__Item').addEventListener("mouseout", function (e) {
    closeDropdown(menu, dropDown, item);
  });

  document.addEventListener('focusin', function () {
    if (!dropDown.contains(document.activeElement)) {
      closeDropdown(menu, dropDown, item);
    }
  }, true);
})

/* Loading Vimeo Videos */
function hwAddVimeoAPI(containerID) {
  var vimeoScript = document.getElementById(window.theme.vimeo.id);
  if (!vimeoScript) {
    var el = document.createElement('script');
    el.setAttribute('src', window.theme.vimeo.js);
    el.setAttribute('id', window.theme.vimeo.id);
    document.head.appendChild(el);
  }
  var timeout = setInterval(function () {
    if (typeof Vimeo != 'undefined') {
      clearInterval(timeout);
      hwCreateVimeoPlayer(containerID);
    }
  }, 100);
}

function hwCreateVimeoPlayer(containerID) {
  var player = new Vimeo.Player(containerID);
  if(document.getElementById(containerID).hasAttribute('data-vimeo-muted')){
    player.ready().then(function() {
      player.setMuted(true);
    });
  }
  return player;
}

function hwInitVimeo(el) {
  var containerID = el.getAttribute('data-vimeo-container');
  if (!containerID) {
    containerID = el.id;
  }
  var vimeoContainer = document.getElementById(containerID);
  if (vimeoContainer) {
    vimeoContainer.classList.remove('hide');
    hwAddVimeoAPI(containerID);
    if(el.classList.contains('vimeo-load-replace')){
      el.remove();
    }
  }
}

window.addEventListener('DOMContentLoaded', function () {
  var vimeoBtns = document.querySelectorAll('.vimeo-load');
  var vimeoVideos = document.querySelectorAll('.vimeo-video');

  vimeoBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      hwInitVimeo(this);
    });
  });

  var videoHandler = function (entries, observer) {
    entries.forEach(function (entry) {
      var el = entry.target;
      if (!entry.isIntersecting || window.getComputedStyle(el).display === "none") return;
      videoObserver.unobserve(el);
      hwInitVimeo(el);
    });
  }

  var videoObserver = new IntersectionObserver(videoHandler, { rootMargin: '200px 0px 200px 0px' });
  vimeoVideos.forEach(function (video) {
    videoObserver.observe(video);
  });
});

/* Swiper Sliders */
function hwAddSwiper(el,opts) {
  var swiperScript = document.getElementById(window.theme.swiper.id);
  if (!swiperScript) {
    var script = document.createElement('script');
    script.setAttribute('src', window.theme.swiper.js);
    script.setAttribute('id', window.theme.swiper.id);
    document.head.appendChild(script);
    var styles = document.createElement('link');
    styles.setAttribute('href', window.theme.swiper.css);
    styles.setAttribute('rel', 'stylesheet');
    styles.setAttribute('id', 'swiper-css');
    document.head.appendChild(styles);
  }
  var timeout = setInterval(function () {
    if (typeof Swiper != 'undefined') {
      clearInterval(timeout);
      hwInitSwiper(el,opts);
    }
  }, 100);
}

function hwInitSwiper(el,opts) {
  var sectionID = el.dataset.sectionId;
  var options = opts || window.swiperOptions[sectionID];
  options.preloadImages = true;
  options.updateOnImagesReady = true;
  options.on = options.on || {};
  options.on.imagesReady = function (swiper) { setTimeout(function () { swiper.update(); }, 1000) };
  var selector = '#' + el.id;
  var sliderType = el.dataset.sliderType || 'always';
  var swiper = null;
  if (sliderType == 'mobile') {
    if (window.matchMedia("(max-width: 767px)").matches) {
      swiper = new Swiper(selector, options);
    }
    window.addEventListener('resize', function () {
      if (window.matchMedia("(min-width: 768px)").matches && swiper !== null) {
        swiper.destroy();
        swiper = null;
      } else if (window.matchMedia("(max-width: 767px)").matches && swiper == null) {
        swiper = new Swiper(selector, options);
      }
    });
  } else if(sliderType == 'desktop'){
    if (window.matchMedia("(min-width: 768px)").matches) {
      swiper = new Swiper(selector, options);
    }
    window.addEventListener('resize', function () {
      if (window.matchMedia("(max-width: 767px)").matches && swiper !== null) {
        swiper.destroy();
        swiper = null;
      } else if (window.matchMedia("(min-width: 768px)").matches && swiper == null) {
        swiper = new Swiper(selector, options);
      }
    });
  } else {
    swiper = new Swiper(selector, options);
  }
  return swiper;
}

window.addEventListener('DOMContentLoaded', function () {
  var swipers = document.querySelectorAll('.swiper-slider');
  var swiperHandler = function (entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      swiperObserver.unobserve(el);
      hwAddSwiper(el);
    });
  }
  var swiperObserver = new IntersectionObserver(swiperHandler, { rootMargin: '400px 0px 400px 0px' });
  swipers.forEach(function (el) {
    swiperObserver.observe(el);
  });

  if (Shopify.designMode) {
    window.addEventListener('shopify:section:load', function (e) {
      swipers.forEach(function (el) {
        hwAddSwiper(el);
      });
    });
  }

});

window.addEventListener('DOMContentLoaded', function () {
  var videos = document.querySelectorAll('.html5-video');
  var clickVideos = document.querySelectorAll('.html5-video-button');

  var videoAddHandler = function (entries, observer) {
    entries.forEach((entry) => {
      var el = entry.target;
      if (!entry.isIntersecting) return;
      addVideo(el);
      videoAddObserver.unobserve(el);
    });
  }

  var videoPlayPauseHandler = function (entries, observer) {
    entries.forEach((entry) => {
      var el = entry.target;
      if (entry.isIntersecting) {
        el.play();
      } else {
        var pauseVideo = true;
        var fixedAncestor = el.closest('.fixed');
        if (fixedAncestor) {
          pauseVideo = false;
          if (fixedAncestor.classList.contains('bottom')) {
            pauseVideo = true;
          }
        }
        if (pauseVideo) {
          el.pause();
        }
      }
    });
  }

  var videoAddObserver = new IntersectionObserver(videoAddHandler, { rootMargin: '400px 0px 400px 0px' });
  var videoPlayPauseObserver = new IntersectionObserver(videoPlayPauseHandler, { threshold: 0.5 })
  videos.forEach((el) => {
    videoAddObserver.observe(el);
  });
  clickVideos.forEach((el) => {
    el.addEventListener('click',() => {
      var videoEl = document.getElementById(el.dataset.id);
      if(videoEl){
        videoEl.classList.remove('hide');
        addVideo(videoEl,true);
        el.remove();
      }
    });
  });

  function addVideo(el,playVideo) {
    var sources = el.querySelectorAll('source');
    sources.forEach((source) => {
      source.src = source.dataset.src;
    });
    if(el.closest('.html5-video-wrapper')){
      el.addEventListener('loadedmetadata', function () {
        var ar = this.videoWidth / this.videoHeight;
        el.closest('.html5-video-wrapper').style.setProperty('--aspect-ratio', ar);
      });
    }
    el.load();
    if (el.autoplay) {
      videoPlayPauseObserver.observe(el);
    }
    if(playVideo){
      el.play();
    }
  }
});

// Lazy loaded images callback for aspect ratio
const hwLazyImages = document.querySelectorAll('.Image--lazyAR');
hwLazyImages.forEach((el) => {
  el.addEventListener('lazyloaded',(e) => {
    var ar = (e.target.naturalWidth / e.target.naturalHeight).toFixed(2);
    e.target.closest('.AspectRatio').style.setProperty('--aspect-ratio', ar);
  });
});

// Lazy iframes
var hwIframes = document.querySelectorAll('.iframe-lazy[data-src]');
var hwIframeHandler = function (entries, observer) {
  entries.forEach((entry) => {
    var el = entry.target;
    if (!entry.isIntersecting) return;
    el.src = el.dataset.src;
    hwIframeObserver.unobserve(el);
  });
}
var hwIframeObserver = new IntersectionObserver(hwIframeHandler,{rootMargin: '400px 0px 400px 0px'});
hwIframes.forEach((el) => {
  hwIframeObserver.observe(el);
});


/****** Back to Top Button *******/
window.addEventListener('DOMContentLoaded', function () {
  var goTopBtn = document.getElementById('back-to-top-button');
  function trackScroll() {
    var scrolled = window.pageYOffset;
    var coords = document.documentElement.clientHeight + window.theme.backToTopButton.displayLocation;
    if (scrolled >= coords) {
      goTopBtn.style.display = "flex";
    }
    if (scrolled < coords) {
      goTopBtn.style.display = "none";
    }
  }

  function backToTop() {
    if (window.pageYOffset > 0) {
      window.scroll({ top: 0, behavior: 'smooth' });
    }
  }

  window.addEventListener('scroll', trackScroll);
  goTopBtn.addEventListener('click', backToTop);
});

window.addEventListener('DOMContentLoaded',function(){
  const floatingLabelSelects = document.querySelectorAll('.Form__Select--FloatLabel select');
  function toggleSelectClass(val,el){
    if(val != ""){
      el.classList.add('has-value');
    } else {
      el.classList.remove('has-value');
    }
  }
  floatingLabelSelects.forEach(function(el){
    toggleSelectClass(el.value,el);
    el.addEventListener('change',function(e){
      toggleSelectClass(e.target.value,e.target);
    });
  });

  // Search Redirects
  let savedSearchRedirects = sessionStorage.getItem('hw-search-redirects') || null;
  if(savedSearchRedirects == null){
    setTimeout(function(){
      fetch('/search?view=ajax.redirects').then(response => response.text()).then(data => {
        const parser = new DOMParser();
        const html = parser.parseFromString(data, 'text/html');
        const redirectsEl = html.querySelector('.search-redirects-map');
        if(redirectsEl){
          savedSearchRedirects = JSON.parse(redirectsEl.innerHTML);
          sessionStorage.setItem('hw-search-redirects',redirectsEl.innerHTML);
        }
      });
    }, 5000);
  } else {
    savedSearchRedirects = JSON.parse(savedSearchRedirects);
  }

  document.querySelectorAll('.search-redirect-form').forEach((form) => {
    form.addEventListener('submit',function(e){
      if(savedSearchRedirects){
        e.preventDefault();
        const input = form.querySelector('input[name="q"]');
        hwSearchRedirects(savedSearchRedirects, input.value);
      }
    });
  });
});

// Localization dropdowns
function hwToggleLocalizationSelector(el){
  var selector = document.getElementById(el.getAttribute('aria-controls'));
  var isExpanded = (el.getAttribute('aria-expanded') == 'true');
  if(!isExpanded){
    selector.classList.remove('hide');
    el.setAttribute('aria-expanded','true');
  } else {
    selector.classList.add('hide');
    el.setAttribute('aria-expanded','false');
  }
}

/* Toggle tabindex on focusable elements inside hidden elements */
const hwHiddenEls = document.querySelectorAll('[aria-hidden="true"]:not(svg)');
var hwHiddenElObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation){
    if(mutation.type === "attributes" && mutation.attributeName == 'aria-hidden'){
      if(mutation.target.ariaHidden == 'false'){
        mutation.target.querySelectorAll('[tabindex="-1"]').forEach((el) => {
          el.removeAttribute('tabindex');
          el.setAttribute('data-remove-focus',true);
        });
      } else {
        mutation.target.querySelectorAll('[data-remove-focus]').forEach((el) => {
          el.setAttribute('tabindex','-1');
          el.removeAttribute('data-remove-focus');
        });
      }
    }
  });
});
hwHiddenEls.forEach((el) => {
  hwHiddenElObserver.observe(el,{attributes: true});
});


// progressive-image.js
if (window.addEventListener && 
  window.requestAnimationFrame && 
  document.getElementsByClassName) 
  window.addEventListener('load', function() {

  // start
  var pItem = document.getElementsByClassName('progressive replace'), timer;

  window.addEventListener('scroll', scroller, false);
  window.addEventListener('resize', scroller, false);
  inView();

  // throttled scroll/resize
  function scroller(e) {
    timer = timer || setTimeout(function() {
      timer = null;
      requestAnimationFrame(inView);
    }, 300);
  }

  // image in view?
  function inView() {
    var wT = window.pageYOffset, wB = wT + window.innerHeight, cRect, pT, pB, p = 0;
    while (p < pItem.length) {
      cRect = pItem[p].getBoundingClientRect();
      pT = wT + cRect.top;
      pB = pT + cRect.height;
      if (wT < pB && wB > pT) {
        loadFullImage(pItem[p]);
        pItem[p].classList.remove('replace');
      }
      else p++;
    }
  }

  // replace with full image
  function loadFullImage(item) {
    if (!item || !item.href) return;
    // load image
    var img = new Image();
    if (item.dataset) {
      img.srcset = item.dataset.srcset || '';
      img.sizes = item.dataset.sizes || '';
    }
    img.src = item.href;
    img.className = 'reveal';
    if (img.complete) addImg();
    else img.onload = addImg;

    // replace image
    function addImg() {
      // disable click
      //item.addEventListener('click', function(e) { e.preventDefault(); }, false);
      // add full image
      item.appendChild(img).addEventListener('animationend', function(e) {
        // remove preview image
        var pImg = item.querySelector && item.querySelector('img.preview');
        if (pImg) {
          e.target.alt = pImg.alt || '';
          item.removeChild(pImg);
          e.target.classList.remove('reveal');
        }
      });
    }
  }
}, false);


const hwDOMParser = new DOMParser();
function hwGetATCSuccess(key,variant,qty,eventEl){ // Show add to cart success popup
  const existingPopup = document.getElementById('atc-success');
  if(existingPopup){existingPopup.remove();}
  fetch('/cart?view=ajax.success', {
    credentials: 'same-origin',
    method: "GET",
    headers: {"Content-type": "text/html; charset=UTF-8"}
  }).then((data) => data.text()).then((data) => {
    const html = hwDOMParser.parseFromString(data, 'text/html');
    const atcEl = html.getElementById('atc-success');
    document.body.appendChild(atcEl);
    if(key){
      atcEl.querySelectorAll('.atc-item:not([data-key="'+key+'"])').forEach((el) => {
        el.remove();
      });
    } else {
      atcEl.querySelectorAll('.atc-item').forEach((el,i) => {
        if(i !== 0){el.remove();}
      });
    }
    if(qty){atcEl.querySelector('.atc-item__qty').textContent = qty;}
    atcEl.classList.remove('hide');
    fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${variant.product_id}&intent=complementary`)
      .then(response => response.json())
      .then(({ products }) => {
        const upsellsEl = document.getElementById('atc-success-upsells');
        if (products.length > 0) {
          upsellsEl.innerHTML = '';
          products.forEach((product) => {
            var comparePrice = '';
            if(product.compare_at_price != null && product.compare_at_price != 0){
              comparePrice = `<span class="ProductItem__Price Price Price--compareAt">${formatPrice(product.compare_at_price_min)}</span>`;
            }
            var slide = `<div id="atc-upsell-${product.handle}" class="swiper-slide">
              <div class="ProductItem">
                <a class="ProductItem__Link ImageWrapperLink" href="${product.url}" aria-hidden="true">
                  <div class="ProductItem__ImageWrapper AspectRatio AspectRatio--square">
                    <img class="ProductItem__Image" srcset="${product.images[0]+'&width=350'} 350w, ${product.images[0]+'&width=800'} 800w" sizes="(max-width: 499px) 65vw, (min-width: 500px) and (max-width: 767px) 38vw, (min-width: 768px) and (max-width: 999px) 30vw, 20vw" alt="">
                  </div>
                </a>
                <div class="ProductItem__Info">
                  <a class="ProductItem__Link ProductItem__Info__Link" href="${product.url}">
                    <h2 class="ProductItem__Title">${product.title}</h2>
                    <div class='ProductItem__PriceList ProductItem__Price Price'>
                      <span class="ProductItem__Price Price ${product.compare_at_price != null && product.compare_at_price != 0 ? 'Price--highlight' : '' }">
                        ${product.price_varies || product.tags.includes('FBSCORE') ? 'Starting at ' : ''}
                        ${formatPrice(product.price_min)}
                      </span>
                      ${comparePrice}
                    </div>
                  </a>
                </div>
              </div>
            </div>`;
            upsellsEl.insertAdjacentHTML('beforeend',slide);
            if(product.tags.includes('FBSVARIANTS')){
              fetch(`/products/${product.handle}?view=ajax.data`, {
                credentials: 'same-origin',method: "GET",headers: {"Content-type": "text/html; charset=UTF-8"}
                }).then((response) => response.text()).then((response) => {
                  var data = JSON.parse(response);
                  var upsellLinks = document.querySelectorAll(`#atc-upsell-${data.handle} a`);
                  if(upsellLinks && data.fbs_core_url){
                    upsellLinks.forEach((link) => {
                      link.setAttribute('href',data.fbs_core_url);
                    });
                  }
                });
            }
          });
        }
        const upsellsSlider = document.getElementById('atc-success-upsells-swiper');
        const slider = new Swiper(upsellsSlider,{
          spaceBetween: 5,
          slidesPerView: 1.5,
          breakpoints: {500: {slidesPerView: 2.5},768:{slidesPerView: 3,spaceBetween: 16}},
          navigation: {nextEl: '.atc-success__upsells .swiper-button-next',prevEl: '.atc-success__upsells .swiper-button-prev'}
        });
      });
    hwTrapFocus(atcEl);
    document.querySelectorAll('.atc-success__close').forEach((el) => {
      el.addEventListener('click',(e) => {
        hwCancelTrapFocus(atcEl);
        atcEl.remove();
        if(eventEl){
          hwAddedEvent(variant,qty,eventEl);
        }
      });
    });
  });
}

const hwFocusableElements = (container) => {
  return Array.from(
    container.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [tabindex="0"], [role="button"]')
  )
  .filter(element => element.checkVisibility ? element.checkVisibility() : true );
}

const hwTrapFocus = (modal) => {
  const KEYCODE_TAB = 9;
  const firstFocusableEl = hwFocusableElements(modal)[0];
  firstFocusableEl.focus();

  modal.keydownlistener = function(e) {
    const focusableElements = hwFocusableElements(modal);

    if(e.key === 'Tab' || e.keyCode === KEYCODE_TAB) {
      if(e.shiftKey) { // shift + tab back
        if (document.activeElement == focusableElements[0] || !focusableElements.includes(document.activeElement)) {
          focusableElements[focusableElements.length - 1].focus();
          e.preventDefault();
        }
      } else { // tab forward
        if (document.activeElement == focusableElements[focusableElements.length - 1] || !focusableElements.includes(document.activeElement)) {
          focusableElements[0].focus();
          e.preventDefault();
        }
      }
    }
  };

  document.addEventListener('keydown', modal.keydownlistener);
}

const hwCancelTrapFocus = (modal) => {
  document.removeEventListener('keydown', modal.keydownlistener);
}

function hwAddedEvent(variant,qty,eventEl){ // Render cart drawer
  eventEl.dispatchEvent(new CustomEvent('product:added', {
    bubbles: true,
    detail: {variant: variant,quantity: qty}
  }));
}

window.addEventListener('DOMContentLoaded',() => {
  const hotspotBtns = document.querySelectorAll('.hotspot-btn');
  const hotspotCloses = document.querySelectorAll('.hotspot-mobile-overlay__close');

  if(hotspotBtns){
    function hotspotClose(e){
      const hotspotContainer = e.target.closest('.hotspot-container');
      if(e.target.classList.contains('hotspot-btn') || !hotspotContainer || (e.target.closest('.hotspot-mobile-overlay') && !e.target.classList.contains('hotspot-mobile-overlay__close'))){
        return;
      }
      const activeBtn = hotspotContainer.querySelector('.hotspot-btn.active');
      if(activeBtn){
        activeBtn.classList.remove('active');
        const popupID = activeBtn.getAttribute('aria-controls');
        hotspotContainer.querySelector(`#${popupID}`).classList.add('hide');
        const mobileOverlay = hotspotContainer.querySelector('.hotspot-mobile-overlay');
        if(!mobileOverlay.classList.contains('hide')){
          mobileOverlay.classList.add('hide');
          const swiperEl = document.getElementById(`swiper-${activeBtn.dataset.block}`);
          swiperEl.swiper.destroy();
        }
      }
    }
    document.body.addEventListener('click',(e) => {
      hotspotClose(e);
    });
    hotspotCloses.forEach((btn) => {
      btn.addEventListener('click',(e) => {
        hotspotClose(e);
      });
    });
    hotspotBtns.forEach((btn) => {
      btn.addEventListener('click',() => {
        hotspotBtns.forEach((el) => {
          if(el != btn){
            el.classList.remove('active');
          }
        });
        btn.classList.toggle('active');
        const parentEl = btn.closest('.hotspot-container');
        const hotspotPopups = parentEl.querySelectorAll('.hotspot-popup');
        const hotspotSlides = parentEl.querySelectorAll('.hotspot-popup__box');
        if(window.matchMedia('(max-width: 767px)').matches){
          const blockID = btn.dataset.block;
          const swiperWrapperEl = document.getElementById(`swiper-wrapper-${blockID}`);
          if(swiperWrapperEl.childElementCount == 0){
            hotspotSlides.forEach((el) => {
              const slideNode = el.cloneNode(true);
              swiperWrapperEl.appendChild(slideNode);
            });
          }
          document.getElementById(`hotspot-overlay-${blockID}`).classList.remove('hide');
          const swiperEl = document.getElementById(`swiper-${blockID}`);
          hwAddSwiper(swiperEl,{
            slidesPerView: 'auto',
            spaceBetween: 16,
            centeredSlides: true,
            pagination: {el: `#swiper-pagination-${blockID}`,type: 'fraction'},
            navigation: {nextEl: `#swiper-${blockID} .swiper-button-next`,prevEl: `#swiper-${blockID} .swiper-button-prev`},
            initialSlide: parseInt(btn.dataset.index)
          });
        } else {
          const hotspotID = btn.getAttribute('aria-controls');
          const hotspotPopup = document.getElementById(hotspotID);
          if(hotspotPopup){
            hotspotPopups.forEach((popup) => {
              popup.classList.add('hide');
            });
            if(btn.classList.contains('active')){
              hotspotPopup.classList.remove('hide');
              hotspotPopup.querySelector('a').focus();
            } else {
              hotspotPopup.classList.add('hide');
            }
          }
        }
      });
    });
  }

  const headerDetails = document.querySelectorAll('#header-banners details, #shopify-section-header details');
  if(headerDetails){
    function closeDetails(){
      headerDetails.forEach((el) => {
        if(el.getAttribute('open') !== null){
          el.removeAttribute('open');
        }
      });
    }
    headerDetails.forEach((el) => {
      el.addEventListener('focusout',(e) => {
        setTimeout(function(){
          if(document.activeElement.closest('details') != el){
            el.removeAttribute('open');
          }
        },50);
      });
    });
    document.body.addEventListener('click',(e) => {
      if(e.target.closest('details')){
        return;
      }
      closeDetails();
    });
    document.addEventListener('keyup',(e) => {
      if (e.key == "Escape") {
        closeDetails();
      }
    });
  }

  // A11y for details/summary
  function hwSummaryExpanded(summary){
    const details = summary.closest('details');
    const isOpen = details.hasAttribute('open');
    summary.setAttribute('aria-expanded',`${isOpen}`);
  }
  document.querySelectorAll('#main summary, #sale-offers summary, #header-account-dropdown summary').forEach((summary) => {
    hwSummaryExpanded(summary);
    summary.setAttribute('tabindex','0');
    summary.addEventListener('click',() => {
      setTimeout(function(){
        hwSummaryExpanded(summary);
      },50);
    })
  });

  // Get ga4 cookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // Set ga4 user id cart attribute
  if(!hasGA4AttributesSet && ga4Property != ""){
    setTimeout(function(){
      const ga4Cookie = getCookie("_ga");
      const ga4Cookie2 = getCookie(`_ga_${ga4Property}`);
      if(ga4Cookie && ga4Cookie2){
        const ga4UserId = ga4Cookie.substring(6,ga4Cookie.length);
        const ga4SessionId = ga4Cookie2.split('.')[2];
        const attributes = {
          attributes: {
            '_ga4_user_id': ga4UserId,
            '_ga4_session_id': ga4SessionId
          }
        };
        fetch(`${window.routes.cartUpdateUrl}.js`, {
          body: JSON.stringify(attributes),
          credentials: 'same-origin',
          method: 'POST',
          headers: {'Content-Type': 'application/json','X-Requested-With': 'XMLHttpRequest'}
        });
      }
    },3000);
  }

  // Cookiebot button
  const hwCookiebotBtn = document.getElementById("cookie-settings-btn");
  if(hwCookiebotBtn){
    hwCookiebotBtn.addEventListener("click", function() {
      if (window.Cookiebot) {
        window.Cookiebot.show();
      } else {
        console.warn("Cookiebot is not loaded yet.");
      }
    });
  }
});
